import * as THREE from 'three';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';

export function textLevel(
	scene: THREE.Scene,
	z: number,
	text: string,
	globalWidth: number
): void {
	const loader = new FontLoader();
	const margin = 0;
	// const x1: number = camera.position.x + (camera.left / camera.zoom) + margin;
	const x1: number = -(globalWidth/2)/17.9 + margin;
	const y: number = 0;
	const color: number = 0xB5B5C3;

	loader.load(
		'assets/three/FONT/Proxima_Nova_Regular.json',
		(font: any): void => {
			const textGeometry = new TextGeometry(text, {
				font: font,
				size: 0.3,
				depth: 0.00001,
				curveSegments: 64,
				bevelEnabled: true,
				bevelThickness: 0.01,
				bevelSize: 0.01,
				bevelSegments: 5,
			});

			const textMaterial = new THREE.MeshBasicMaterial({ color: color });
			const textMesh = new THREE.Mesh(textGeometry, textMaterial);

			textMesh.rotation.set(-Math.PI / 2, 0, 0);
			textMesh.position.set(x1, y, z);
			textMesh.userData.followCameraX = true;

			scene.add(textMesh);
		},
		(xhr: ProgressEvent): void => {
			if (xhr.total > 0) {
				// Exemple : console.log((xhr.loaded / xhr.total) * 100 + '% font loaded');
			}
		},
		(err: unknown): void => {
			console.error('An error occurred:', err);
		}
	);
}
